import React, { Component, Fragment } from 'react'
import Breadcrumb from '../common/breadcrumb';
import CurrencyInput from "react-currency-input";
import {
    Input, Label, Row, InputGroup, InputGroupAddon
} from 'reactstrap';
import Swal from "sweetalert2";
import { AvFeedback, AvForm, AvGroup, AvInput, AvRadio, AvRadioGroup } from "availity-reactstrap-validation";
import { IMG_HOST } from "../../helper/host";
import { Upload } from "antd";
import ImgCrop from "antd-img-crop";
import customToast from "../../notification/customToast";
import LoadingScreen from '../loadingScreen/loading';
import CKEditor from "react-ckeditor-component";

export class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataAgenda: [],
            agenda_title: '',
            agenda_date: '',
            note: '',
            keyword: '',
            agenda_type: '',
            isLoading: true,
            firstLoading: true,
            loading: false,
            auth: this.props.auth,
            disabledButton: false,

        }
        this.handleChangePrice = this.handleChangePrice.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.onEditorStateChange = this.onEditorStateChange.bind(this);

    }
    onEditorStateChange(evt) {
        var newContent = evt.editor.getData();
        this.setState({
            desc: newContent
        })
    };
    handleChangePrice(event, maskedvalue) {
        const target = event.target;
        const name = target.name;

        this.setState({ [name]: maskedvalue });
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        })
    }



    handleSubmit = () => {
        this.setState({
            loading: true,
        })
        let form = {
            agenda_id: this.state.dataAgenda.agenda_id,
            agenda_title: this.state.agenda_title,
            agenda_date: this.state.agenda_date,
            agenda_note: this.state.note,
            agenda_type: this.state.agenda_type,
            keyword: this.state.keyword,
        }
        this.props.request("admin/agenda/update", form, 'POST')
            .then(response => {
                if (response.success) {
                    this.setState({
                        isLoading: true,
                        title: '',
                        desc: '',
                        short: '',
                        keyword: '',
                        image: '',
                        fileList: [],

                    })
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.message,
                        icon: 'success'
                    })
                    this.loadData()
                    this.props.history.push('/agenda/list-agenda')
                } else {
                    if (Array.isArray(response.message)) {
                        response.message.map(item => {
                            customToast.error(item)
                            return true
                        })
                    } else {
                        customToast.error(response.message)
                    }
                    this.setState({ isLoading: false })
                }
                if (response.failed) {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.message,
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    })
                }
                setTimeout(() => {
                    this.setState({ loading: false });
                }, 2000);
            });
    }

    demoAsyncCall() {
        return new Promise((resolve) => setTimeout(() => resolve(), 2500));
    }

    loadData() {
        let formData = {
            id: this.props.match.params.id,
            auth: this.props.auth,

        }
        this.props.request("admin/agenda/detail", formData)
            .then(response => {
                if (response.success) {
                    var result = response.data
                    this.setState({
                        dataAgenda: result,
                        modal: false,
                        auth: this.props.auth,
                        isLoading: false,
                        loading: false,
                        agenda_title: result.agenda_title,
                        note: result.agenda_note,
                        agenda_date: result.agenda_date,
                        agenda_type: result.agenda_type,
                        keyword: result.blog_keyword,
                    });
                }
            });
    }

    componentDidMount() {
        this.loadData()
        this.demoAsyncCall().then(() => this.setState({ firstLoading: false }));
    }
    componentWillReceiveProps(newProps) {
        if (newProps.auth !== this.state.auth) {
            this.setState({ auth: newProps.auth })
        }
    }



    render() {
        const { loading } = this.state;
        const { firstLoading } = this.state;
        if (firstLoading) {
            return <LoadingScreen />;
        }

        return (
            <Fragment>
                <Breadcrumb title="Edit Agenda" parent="Agenda" />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="card">
                                <div className="card-body">
                                    <h4>Edit Agenda</h4>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4"><span>*</span> Title</label>
                                        <input name="agenda_title" className="form-control col-xl-8 col-md-7"
                                               placeholder="Judul..."
                                               type="text" required="" onChange={this.handleChange}
                                               value={this.state.agenda_title}/>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4"><span>*</span>Tanggal Agenda</label>
                                        <input name="agenda_date" value={this.state.agenda_date}
                                               className="form-control col-xl-8 col-md-7"
                                               placeholder="Judul..."
                                               type="date" required="" onChange={this.handleChange}/>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4">Tipe Agenda</label>
                                        <select
                                            name="agenda_type"
                                            className="form-control col-xl-8 col-md-7"
                                            value={this.state.agenda_type}
                                            onChange={(event) => {
                                                const target = event.target;
                                                const value = target.value;
                                                const name = target.name;
                                                this.setState({
                                                    [name]: value
                                                });
                                            }}>
                                            <option value="">Pilih Tipe</option>
                                            <option value="liburnasional">libur nasional</option>
                                            <option value="liburperusahaan">libur perusahaan</option>
                                            <option value="acara">acara</option>
                                        </select>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4"><span>*</span> Note</label>
                                        <Input className="form-control col-md-12"
                                               type="textarea" placeholder="Deskripsi Singkat.." required=""
                                               onChange={this.handleChange} value={this.state.note}/>
                                    </div>
                                    <div className="pull-right">
                                        <button type="button" className="btn btn-primary" onClick={this.handleSubmit}
                                                disabled={loading}>
                                            {loading && (
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{marginRight: "5px"}}
                                                />
                                            )}
                                            {loading && <span>Simpan</span>}
                                            {!loading && <span>Simpan</span>}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default Edit
